import { render, staticRenderFns } from "./LiveListPage.vue?vue&type=template&id=fdea8182"
import script from "./LiveListPage.vue?vue&type=script&lang=js"
export * from "./LiveListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports